import React from 'react'
import classes from './Leaderboards.scss'
import GameItem from '../GameList/GameItem'
import GameListClasses from '../GameList/GameList.scss'
import 'whatwg-fetch'

class Leaderboards extends React.Component {

  constructor(props) {
    super(props)

    const self: any = this
    self.state = { scores: [], loading: false }
    self.renderScores = self.renderScores.bind(self)
  }

  typeNames() {
    return ({
      'daily': 'Daily',
      'weekly': 'Weekly',
      'alltime': 'All-Time',
    })
  }

  componentWillMount() {
    const { baseUrl, type } = this.props
    this.setState({ loading: true })
    fetch(`${baseUrl}/leaders/${type}`, { credentials: 'include' })
      .then(res => res.json())
      .then(res => {
        if (res.result === 'ok') {
          const { scores } = res
          this.setState({ scores })
        } else {
          console.log(res.err || res.msg || res.message)
        }
        this.setState({ loading: false })
      })
      .catch((err) => console.log(err))
  }

  renderScores() {
    const { scores } = this.state
    return scores.map(s => <GameItem key={s.id} first={s.displayName} second={s.score} star={s.admin} onClick={() => window.location.href = `/profile/${s.username}`} />)
  }

  render() {
    const { scores, loading } = this.state
    const { type } = this.props
    const typeName = this.typeNames()[type]

    return (
      <div className={classes.leaderboards}>
        <h1>{typeName} Leaderboards</h1>
        <ul className={GameListClasses.headers} style={{ top: '-10px' }}>
          <li>Username</li>
          <li>Score</li>
        </ul>
        {loading && <h3 className={GameListClasses.loading} style={{ marginTop: '3em', marginBottom: '2em' }}>Loading...</h3>}
        {!loading && this.renderScores()}
        <span style={{ display: 'inline-block', marginTop: '2em' }}>Updated every 5 minutes</span>
      </div>
    )
  }
}

export default Leaderboards



/** WEBPACK FOOTER **
 ** ./src/components/Leaderboards/Leaderboards.js
 **/